import { theme } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const ContentHero = styled.div`
  h1 {
    font-size: 3.125rem;
    font-family: "Barlow", "sans-serif";
    margin-bottom: var(--chakra-space-4);
    font-weight: 700;
    color: var(--chakra-colors-blue700);
  }
  h5 {
    font-size: 1.25rem;
    font-family: "Barlow", "sans-serif";
    font-weight: 700;
    line-height: 1.5rem;
    margin-bottom: var(--chakra-space-4);
  }
  p {
    margin-bottom: var(--chakra-space-5);
  }
  .parent {
    display: grid;
    grid-gap: var(--chakra-space-5);
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .detail {
    margin-top: var(--chakra-space-14);
    margin-bottom: var(--chakra-space-14);
  }

  .intro-text {
    text-align: center;
    margin-bottom: var(--chakra-space-20);
    h3 {
      font-size: 1.875rem;
      font-family: "Barlow";
      font-weight: 600;
      font-size: 30px;
      margin-bottom: 1.125rem;
    }
    p {
      width: 40%;
      margin: 0 auto;
    }
  }

  .intro-grid {
    display: grid;
    grid-gap: var(--chakra-space-14);
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .image {
    margin: 0 auto;
  }

  @media (min-width: ${theme.breakpoints.md}) {
    .intro-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .parent {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (min-width: ${theme.breakpoints.lg}) {
    .intro-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
`;

export const ContentFipsHero = styled.div`
  h1 {
    font-size: 3.125rem;
    font-family: "Barlow", "sans-serif";
    margin-bottom: var(--chakra-space-4);
    font-weight: 700;
    color: var(--chakra-colors-blue700);
  }
  .parent {
    display: grid;
    grid-gap: var(--chakra-space-5);
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .detail {
    width: 100%;
    margin: 0 auto;
  }
  h3 {
    font-size: 1.875rem;
    font-family: "Barlow";
    font-weight: 600;
    margin-bottom: 1.125rem;
  }
  p {
    margin-bottom: var(--chakra-space-5);
  }
  .detail {
    margin-top: var(--chakra-space-14);
    margin-bottom: var(--chakra-space-14);
  }
  a {
    color: var(--chakra-colors-blue500);
    font-size: 1rem;
    font-family: "Barlow";
    font-weight: 700;
    margin-bottom: 1.125rem;
  }
  .image,
  img {
    margin: 0 auto;
  }

  @media (min-width: ${theme.breakpoints.md}) {
    .parent {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .detail {
      width: 70%;
    }
  }
`;
